// vue components  列表数据字段名对应 Remark
const layout = import('../layout/index.vue'); //外层框架
const home = import('../views/Home.vue'); //主页
// const documentation = import('../views/documentation.vue'); //主页

// 医院管理
const hospitallist = import('../views/hospital/list.vue'); //医院列表
const hospitallistmy = import('../views/hospital/listmy.vue'); //医院列表 我的
const hospitaldetail = import('../views/hospital/detail/index.vue'); //医院详情
// 服务器管理
const serverdetail = import('../views/server/detail.vue'); //详情
// 工单管理
const workorderlist = import('../views/hospital/workorder/search.vue'); //列表查询
const workorderlistmy = import('../views/hospital/workorder/searchmy.vue'); //列表查询 我的
const workorderdetail = import('../views/hospital/workorder/detail.vue'); //详情
// 系统管理
// 用户
const userlist = import('../views/system/user.vue'); //用户列表
const permission = import('../views/system/permission.vue'); //评级管理
// 项目统计
const statisticslist = import('../views/statistics/index.vue'); //统计列表
// 项目管理
const projectdetail = import('../views/hospital/project/detail.vue'); //项目详情

const duty = import('../views/duty/index.vue'); //排班

const ddiframe = import('../views/ddverify/test.vue'); //详情
function look(n) {
  switch (n) {
    case 'home':
      return home
      break;
    case 'layout':
      return layout
      break;

    case 'hospitallist':
      return hospitallist
      break;
    case 'hospitallistmy':
      return hospitallistmy
      break;
    case 'hospitaldetail':
      return hospitaldetail
      break;
    case 'serverdetail':
      return serverdetail
      break;
    case 'workorderlist':
      return workorderlist
      break;
    case 'workorderlistmy':
      return workorderlistmy
      break;
    case 'workorderdetail':
      return workorderdetail
      break;
    case 'statisticslist':
      return statisticslist
      break;
    case 'projectdetail':
      return projectdetail
      break;
    case 'userlist':
      return userlist
      break;
    case 'permission':
      return permission
      break;
    case 'duty':
      return duty
      break;
    case 'ddverify':
      return ddverify
      break;
    case 'ddiframe':
      return ddiframe
      break;

    default:
      return home
      break;
  }
}

export default (name) => () => look(name);



// WEBPACK FOOTER //
// ./src/modules/web/utils/lazyLoading.js